import { useBadgeData } from './useBadgeCounts';

export const WORKFLOW_NOTIFICATIONS_QUERY_KEY = ['workflow-notifications'];

/** Own notifications that haven't been hidden yet. */
export function useWorkflowNotificationCount() {
  return useBadgeData().data?.workflow_notifications ?? 0;
}
